import { useAuth, useUser } from "contexts";
import useProgress from "hooks/useProgress";
import { createContext, useContext, useEffect, useState } from "react";
import { createStory } from "services/stories";
import { removeLogs } from "services/users";
import { StoryStatus } from "data/enums";

const Create = createContext();

export function CreateProvider({ children }) {
  const { profile } = useUser();
  const { user } = useAuth();

  const [storyId, setStoryId] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const [progress, resetProgress] = useProgress(loading);

  const handleCreate = async (values) => {
    if (loading || !user?.uid) return;

    setLoading(true);

    await createStory({
      settings: {
        images_style: values.imagesStyle,
      },
      storyData: {
        buddy_name: values.buddyName,
        buddy_description: values.buddyDescription,
        buddy_relationship: values.buddyRelationship,
        challenge: values.development,
        kid_age: values.protagonistAge.toString(),
        kid_description: values.protagonistDescription,
        kid_name: values.protagonistName,
        learning: values.theme,
        scenario: values.settingPlace,
        title: values.title,
      },
      userCredits: {
        author: profile.name,
        is_public: "false",
        user_id: user.uid,
      },
    });
  };

  const handleReset = () => {
    if (loading || success || error || storyId) {
      setLoading(false);
      setSuccess(false);
      setStoryId(null);
      setError(null);
      resetProgress();
    }
  };

  useEffect(() => {
    const log = Object.values(profile?.logs || {})?.[0];

    if (log) {
      if (log.status === StoryStatus.PENDING) {
        setLoading(true);
      } else {
        setLoading(false);

        if (log.status === StoryStatus.SUCCESS) {
          setStoryId(log.story_id);
          setSuccess(true);
        } else if (
          log.status === StoryStatus.ERROR ||
          log.status === StoryStatus.FAILED
        ) {
          setError("Error al crear la historia.");
          console.log(log.message);
        }

        removeLogs();
      }
    }
  }, [profile?.logs]);

  return (
    <Create.Provider
      value={{
        completed: success || loading || error || storyId,
        error,
        handleCreate,
        handleReset,
        loading,
        progress,
        storyId,
        success,
      }}
    >
      {children}
    </Create.Provider>
  );
}

export const useCreate = () => useContext(Create);
